import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RabSelectionType {
    isSelect: boolean;
    borderLeft: boolean | undefined;
    borderRight: boolean | undefined;
    variant: DefaultComponentVariantType | null;
}

const setSelectionRabListItem = (
    variant: DefaultComponentVariantType | null,
    theme: EmotionTheme,
    isSelect: boolean,
    borderLeft: boolean | undefined,
    borderRight: boolean | undefined
): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            background: ${theme.star.selectionsGroup.bgColor};
            border-radius: ${theme.star.radius.medium};
            overflow: hidden;
        `;
    }
    return css`
        background: ${isSelect ? theme.star.rabSelection.bgColorTertiary : theme.star.selectionsGroup.bgColor};
        border: 1px solid ${theme.star.selectionsGroup.borderColor};
        border-left: ${borderLeft === true ? `1px solid ${theme.star.selectionsGroup.borderColor}` : 'none'};
        border-right: ${borderRight === false ? 'none' : `1px solid ${theme.star.selectionsGroup.borderColor}`};
        ${isSelect ? `color: ${theme.star.rabSelection.txtColor}` : ''};
        font-weight: ${isSelect ? theme.star.fontWeight.bold : theme.star.fontWeight.regular};
        flex: 1 1 0%;
    `;
};

export const SelectionRabListItem = withConfig(theme => styled('li', { label: 'SelectionRabListItem' }) <RabSelectionType>`
    ${({ variant, isSelect, borderLeft, borderRight }): SerializedStyles => setSelectionRabListItem(variant, theme, isSelect, borderLeft, borderRight)}
    border-top: none;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
    z-index: ${theme.star.zIndexGlobal.base};
    &:first-of-type {
        left: ${({ borderLeft }): string => borderLeft === true ? '1px;' : '0;'};
    }
`);

interface SelectionRabListItemNameType {
    marketTemplateType: string | undefined;
}

const renderNamesInColumn = (marketTemplateType: string | undefined): SerializedStyles => {
    if (marketTemplateType === 'WinningMargin' || marketTemplateType === 'HalfWinningMargin') {
        return css`
            flex-direction: column;
            align-items: start;
        `;
    }
    return css``;
};

export const SelectionRabListItemName = styled('span', { label: 'SelectionRabListItemName' })<SelectionRabListItemNameType>`
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    padding: 11px 10px;
    line-height: 1.5;
    ${({ marketTemplateType }): SerializedStyles => renderNamesInColumn(marketTemplateType)};
`;

interface SelectItemType {
    isSelect: boolean;
}

export const SelectItem = withConfig(theme => styled('div', { label: 'SelectItem' }) <SelectItemType>`
    align-self: center;
    height: 16px;
    position: relative;
    width: 16px;
    &::before,
    &::after {
        background-color: ${theme.star.rabSelection.bgColor};
        bottom: 0;
        content: '';
        height: 2px;
        left: 0;
        margin: auto;
        position: absolute;
        right: 0;
        top: 0;
        transition: transform .2s ease;
        width: 16px;
    }
    ${({ isSelect }): SerializedStyles => isSelect ? css`
        width: 16px;
        &::before,
        &::after {
            background-color: ${theme.star.rabSelection.bgColorSecondary};
            width: 16px;
        }
        &::before {
            left: -12px;
            top: 6px;
            transform: rotate(-135deg);
            width: 8px;
        }
        &::after {
            left: 2px;
            transform: rotate(-45deg);
            width: 16px;
        }
        ` : css`
            &::after {
                transform: rotate(90deg);
            }
    `}
`);

interface SelectItemType {
    isSelect: boolean;
    variant: DefaultComponentVariantType | null;
}

const setSelection = (
    variant: DefaultComponentVariantType | null, theme: EmotionTheme, isSelect: boolean,): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            background-color: ${isSelect ? theme.star.rabSelection.bgColorTertiary : 'transparent'};
            border: 1px solid ${theme.star.rabSelection.borderColor};
            border-radius: 4px;
            margin: 4px;
            width: 64px;
            height: 48px;
        `;
    }
    return css`
        width: 48px;
        @media ${theme.star.mediaQuery.tablet} {
            width: 63px;
        }
    `;
};

export const Selection = withConfig(theme => styled('div', { label: 'Selection' })<SelectItemType>`
    ${({ variant, isSelect }): SerializedStyles => setSelection(variant, theme, isSelect)}
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;
`);

export const SelectionRabListItemCutName = styled('span', { label: 'SelectionRabListItemCutName' })`
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 190px;
    margin-right: 5px;
    white-space: nowrap;
`;
